import React from 'react';
import { Box, Typography } from '@mui/material';

const QualityControl: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h2">Quality Control</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Placeholder page for quality control dashboard and checks.
      </Typography>
    </Box>
  );
};

export default QualityControl;